/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import barrow from '../../../common/images/arrow-left.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setOrder } from '../../../store/reducers/order';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import useNavigation from '../../../hook/useNavigation';
import { sendAnalyticsCustomEvent, trackMetaPixelEvent } from '../../../utils/helper';

const Tabs = () => {
	const dispatch = useDispatch();

	const tab = useSelector((state) => state?.order?.tab);
	const [selected, setSelected] = useState('pesanan');
	const tabs = [
		{
			id: 'pesanan',
			name: 'Pesanan',
		},
		{
			id: 'topup',
			name: 'Top Up',
		},
	];

	useEffect(() => {
		setSelected(tab);
	}, []);

	return (
		<div className='flex gap-10 px-8'>
			{tabs?.map((tab, index) => {
				return (
					<div
						key={index}
						onClick={() => {
							if(tab?.id === 'topup'){
								sendAnalyticsCustomEvent('topup_history_session');
								trackMetaPixelEvent('topup_history_session');
							}
							setSelected(tab?.id);
							dispatch(setOrder({ tab: tab?.id }));
						}}
						className={selected === tab?.id ? `pb-3 text-[var(--rose-violet)] text-sm font-semibold border-b-1 border-solid border-[var(--rose-violet)]` : `pb-3 text-gray-400 text-sm`}>
						{tab?.name}
					</div>
				);
			})}
		</div>
	);
};

function Header() {
  const navigate = useNavigation();
  const user = useSelector((store) => store?.user)
	return (
		<div className='flex flex-col border-b-1 border-solid border-gray-300'>
			<div className='flex items-center p-4 sticky top-0 z-10 bg-white'>
        <ArrowLeftIcon id='order_history_back' className='h-8 w-8 text-gray-900 bg-white rounded-full p-1.5 font-semibold' onClick={() => navigate.push('/')} />
				<h2 className='text-base font-semibold ml-2'>Riwayat Pesanan</h2>
			</div>
			{!user?.is_b2b && <Tabs />}
		</div>
	);
}

export default Header;
